import { render, staticRenderFns } from "./MappingTable.vue?vue&type=template&id=4af58106&"
import script from "./MappingTable.vue?vue&type=script&lang=js&"
export * from "./MappingTable.vue?vue&type=script&lang=js&"
import style0 from "./MappingTable.vue?vue&type=style&index=0&id=4af58106&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports